import React from 'react';
import {
  makeStyles,
  Button,
  Grid,
  AppBar,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import styles from './styles';

export default function FormActionButtons(props) {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const {
    id,
    assistText,
    cancelText = 'Cancel',
    customClasses = {},
    nextText = 'Next',
    additionalText = 'Save',
    onCancelClick,
    onNextClick,
    onAdditionalClick,
    showCancel = true,
    showNext = true,
    showAdditional = false,
    isDisabled = false,
    isDisabledAdditional = true,
    isContainerFooter = false,
    containerClass,
  } = props;

  return (
    <AppBar
      className={clsx(containerClass, classes.appBar)}
      id={id}
      data-apim-test={id}
      data-layer7-test={id}
    >
      <Grid container>
        {!isContainerFooter && <Grid md={2} item />}
        <Grid md={2} item className={classes.cancelContainer}>
          {showCancel &&
            <Button
              id="cancel-button"
              data-apim-test="cancel-button"
              color="primary"
              variant="outlined"
              className={clsx(classes.cancelButton, customClasses.cancelButton)}
              onClick={() => onCancelClick()}
            >
              {cancelText}
            </Button>
          }
        </Grid>
        <Grid md={isContainerFooter ? 10: 5} item>
          <div className={classes.saveContainer}>
            {assistText &&
              <div className={classes.assistText} data-apim-test="assist-text">{assistText}</div>
            }
            {showAdditional &&
              <Button
                id="additonal-button"
                data-apim-test="additonal-button"
                variant="contained"
                color="secondary"
                className={clsx(classes.saveButton, customClasses.additionalButton)}
                onClick={() => onAdditionalClick()}
                disabled={isDisabledAdditional}
              >
                {additionalText}
              </Button>
            }
            {showNext &&
              <Button
                id="next-button"
                data-apim-test="next-button"
                variant="contained"
                color="secondary"
                className={clsx(classes.saveButton, customClasses.nextButton)}
                onClick={() => onNextClick()}
                disabled={isDisabled}
              >
                {nextText}
              </Button>
            }
          </div>
        </Grid>
        {!isContainerFooter && <Grid md={2} item />}
      </Grid>
    </AppBar>
  );
}

FormActionButtons.propTypes = {
  additionalText: PropTypes.string,
  assistText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  cancelText: PropTypes.string,
  containerClass:  PropTypes.string,
  customClasses: PropTypes.object,
  id: PropTypes.string,
  isContainerFooter: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isDisabledAdditional: PropTypes.bool,
  nextText: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.shape({})]),
  onAdditionalClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  onNextClick: PropTypes.func,
  showAdditional: PropTypes.bool,
  showCancel: PropTypes.bool,
  showNext: PropTypes.bool,
};
